<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card-header-primary">
        <h4 class="card-title">Profile</h4>
        <p class="card-category">
          Your store as FishyHub has it. To change your brand name, email, contact or address,
          contact FishyHub support; change your logo from the photo in the menu.
        </p>
      </div>
      <div class="card-body">
        @if (loading()) {
          <p class="text-muted">Loading…</p>
        } @else {
        @if (profile(); as p) {
          <div class="profile-head">
            @if (p.logoUrl) {
              <img class="logo" [src]="p.logoUrl" alt="Store logo" />
            } @else {
              <span class="logo logo-initial">{{ (p.brandName || 'F').charAt(0).toUpperCase() }}</span>
            }
            <div>
              <p class="brand">{{ p.brandName || '—' }}</p>
              @if (p.isStarSeller) {
                <span class="text-muted" style="font-size: 13px;">★ Star Seller</span>
              }
            </div>
          </div>

          <dl class="details">
            <dt>Brand name</dt>
            <dd>{{ p.brandName || '—' }}</dd>
            @if (p.lastName) {
              <dt>Last name</dt>
              <dd>{{ p.lastName }}</dd>
            }
            <dt>Email</dt>
            <dd>{{ p.email || '—' }}</dd>
            <dt>Contact</dt>
            <dd>{{ phone(p) }}</dd>
            <dt>Address</dt>
            <dd>{{ address(p) }}</dd>
            <dt>Country</dt>
            <dd>{{ p.country || '—' }}</dd>
            @if (p.memberSince) {
              <dt>On FishyHub since</dt>
              <dd>{{ p.memberSince | date: 'mediumDate' }}</dd>
            }
          </dl>

          <h5 style="margin-bottom: 4px;">Store description</h5>
          <p class="text-muted" style="font-size: 13px; margin-bottom: 8px;">
            A few lines about your store, shown under your logo on your store page, above Follow
            and Share. Up to {{ max }} characters; leave it empty to show nothing.
          </p>
          <textarea
            [formControl]="descriptionControl"
            placeholder="e.g. Family-run fish farm in Lim Chu Kang, breeding show-grade bettas and guppies since 2008."
            aria-label="Store description"
          ></textarea>
          <div class="counter" [class.over]="tooLong()">{{ length() }}/{{ max }}</div>

          <div class="mt-3">
            <button
              mat-raised-button
              color="primary"
              (click)="save()"
              [disabled]="saving() || tooLong()"
            >
              {{ saving() ? 'Saving…' : 'Save' }}
            </button>
          </div>

          @if (success()) {
            <div class="alert alert-success mt-3">{{ success() }}</div>
          }
        }
        }
        @if (error()) {
          <div class="alert alert-danger mt-3">{{ error() }}</div>
        }
      </div>
    </div>
  </div>
</div>
